<template>
    <v-breadcrumbs :items="items" class="app-breadcrumbs pa-0 mb-2" density="compact">
        <template v-slot:divider>
            <v-icon size="small" color="#94a3b8">mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
            <v-breadcrumbs-item :to="item.to" :disabled="item.disabled" class="app-breadcrumbs-item">
                <v-icon v-if="item.icon" size="small" class="mr-1">{{ item.icon }}</v-icon>
                {{ item.title }}
            </v-breadcrumbs-item>
        </template>
    </v-breadcrumbs>
</template>

<script>
export default {
    name: 'Breadcrumbs',
    computed: {
        items() {
            const crumbs = (this.$route.meta && this.$route.meta.breadcrumb) || [];
            const items = [
                {
                    title: 'Accueil',
                    icon: 'mdi-home-outline',
                    to: { name: 'DemandeAlumniIndex' },
                    disabled: this.$route.name === 'DemandeAlumniIndex'
                }
            ];
            crumbs.forEach((crumb, index) => {
                items.push({
                    title: crumb.text,
                    to: crumb.name ? { name: crumb.name, params: this.$route.params } : undefined,
                    disabled: index === crumbs.length - 1
                });
            });
            return items;
        }
    }
};
</script>

<style scoped>
.app-breadcrumbs {
    flex-wrap: wrap;
}
.app-breadcrumbs :deep(.v-breadcrumbs-item) {
    color: #2563eb;
    font-size: 0.8rem;
    font-weight: 500;
}
.app-breadcrumbs :deep(.v-breadcrumbs-item--disabled) {
    color: #64748b;
    font-weight: 600;
    opacity: 1;
}
.v-theme--dark .app-breadcrumbs :deep(.v-breadcrumbs-item) {
    color: #60a5fa;
}
.v-theme--dark .app-breadcrumbs :deep(.v-breadcrumbs-item--disabled) {
    color: #94a3b8;
}
</style>
